<template>
  <avue-tree 
    ref="treeRef"
    node-key="id"
    :option="treeOption"
    :data="treeData"
    v-model="form"
    @node-click="treeNodeClick">
    <template #="{ node, data }">
      <span class="el-tree-node__label">
        <template v-if="node.data.childTreeList && node.data.childTreeList.length">
          <i class="icon-menu2_03" style="padding:0 4px; font-size: 16px;"></i>
        </template>
        {{ (node || {}).data.title }}
      </span>
    </template>
    <template #menu="{ node }">
      <div class="avue-tree__item" @click="view(node)">{{ Lang.Button.userOrgDetail }}</div>
      <div class="avue-tree__item" @click="edit(node)">{{ Lang.Button.userOrgEdit }}</div>
      <div v-if="!node.data.hasChildren" class="avue-tree__item" @click="del(node)">{{ Lang.Button.userOrgDelete }}</div>
    </template>
  </avue-tree>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick  } from 'vue';
import { getDeptTree, } from '@/api/system/dept';
import { Lang } from '@/lang/lang';
import store from '@/store';

const props = defineProps({
  operation: {
    type: String,
    default: 'add',
  },
});

const form = reactive({});
const treeData = ref([]);
const treeOption = reactive({
  nodeKey: 'id',
  filterText: Lang.tips.plzInputFilterText,
  defaultExpandAll: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  props: {
    labelText: Lang.tips.title,
    label: 'title',
    value: 'key',
    children: 'children',
  },
});

const treeRef = ref(null);
const currentNode = ref(null);


const updateSideList = (list) => {
  treeData.value = [];
  if (list.length) {
    treeData.value = list;
    emit('getData', list);
  }
};
const emit = defineEmits(['nodeClick', 'add', 'edit', 'view', 'delete', 'refresh', 'getData']);

const add = (node) => emit('add', node);
const edit = (node) => emit('edit', node);
const view = (node) => emit('view', node);
const del = (node) => emit('delete', node);

const treeNodeClick = (data, Node, node) => {
  currentNode.value = data;
  emit('nodeClick', data, Node, treeData);
};



// 初始化获取树形数据
onMounted(() => {
  getTreeData();
});

// 默认选中第一个
const selectedFirstItem = (list) => {
  const firstItem = list[0];
  if (!firstItem) {
    return;
  }
  treeNodeClick(firstItem);
  // if (firstItem.children) {
  //   const children = firstItem.children;
  //   const secondLevelFirstItem = children[0];
  //   if (secondLevelFirstItem && secondLevelFirstItem.id) {
  //     if (treeRef && treeRef.value) {
  //       treeRef.value.setCheckedKeys([secondLevelFirstItem.id]);
  //       treeRef.value.setCurrentKey(secondLevelFirstItem.id);
  //     }
  //     treeNodeClick(secondLevelFirstItem);
  //   }
  // } else {
  //   if (treeRef && treeRef.value) {
  //     treeRef.value.setCheckedKeys([firstItem.id]);
  //     treeRef.value.setCurrentKey(firstItem.id);
  //   }
  //   treeNodeClick(firstItem);
  // }
};

const getTreeData = async () => {
  const res = await getDeptTree({tenantId: store.state.user.tenant_id, deptId: store.state.user.dept_id});
  const list = res.data.data;
  updateSideList(list);
  if (!currentNode.value) {
    nextTick(() => {
      selectedFirstItem(list)
    })
  }
};

defineExpose({
  getTreeData,
})
</script>
